import { RadioGroup } from '@headlessui/react';

import OptionContainer from './OptionContainer';
import OptionLabel from './OptionLabel';

interface Props {
  value: string;
  onChange?: (value: string) => void;
  isSelected: boolean;
}

const RadioOption = ({ value, isSelected }: Props) => {
  return (
    <OptionContainer paddingClassName="px-0 py-1">
      <div className="flex flex-row items-center gap-x-2">
        <span className="flex h-4 w-4 items-center justify-center rounded-full border border-[#111827] bg-white">
          {isSelected ? <span className="h-2 w-2 rounded-full bg-[#111827]">&nbsp;</span> : null}
        </span>
        <RadioGroup.Label>
          <OptionLabel isSelected={isSelected}>{value}</OptionLabel>
        </RadioGroup.Label>
      </div>
    </OptionContainer>
  );
};

export default RadioOption;
